import Box from "@mui/material/Box";
import type { Dispatch, SetStateAction } from "react";
import { useContext } from "react";

import { zinc } from "@/components/DriverView/ui/colors";
import FeedFooter from "@/components/FeedFooter";
import FeedVirtualizedList from "@/components/feed/FeedVirtualizedList";
import GlobalAudioPlayer from "@/components/GlobalAudioPlayer";
import { feedFooterHeight, footerTransitionSx, globalAudioPlayerHeight } from "@/components/NewDesign/newDesignUtils";
import type { Feed } from "@/db/types";
import { UxContext } from "@/models/UxStateProvider";
import FeedAliasHeader from "./FeedAliasHeader";
import FeedHeader from "./FeedHeader";

export default function DriverCentricFeed({
  currentFeedDate,
  setRenderToggle,
  aliasAccount,
  feed,
}: {
  currentFeedDate: Date | null;
  setRenderToggle: Dispatch<SetStateAction<string>>;
  aliasAccount: { id: string; name: string; alias: string; title: string } | null;
  feed: Feed;
}) {
  const { feedViewCollapsed } = useContext(UxContext);
  const hasActiveGlobalAudioPlayerHeight = feedViewCollapsed ? globalAudioPlayerHeight : 0;

  return (
    <Box
      sx={{
        height: "100%",
        overflow: "hidden",
        bgcolor: "black",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ px: 2, pt: 1 }}>
        {aliasAccount ? <FeedAliasHeader aliasAccount={aliasAccount} /> : <FeedHeader feed={feed} />}
      </Box>
      <Box sx={{ flex: 1, bgcolor: "black", position: "relative", overflow: "hidden" }}>
        <Box
          sx={{
            height: "100%",
            pb: `${feedFooterHeight}px`,
            "& [aria-label='Feed items list'] > div > div > div": { px: 2 },
          }}
        >
          <FeedVirtualizedList
            currentFeedDate={currentFeedDate}
            setRenderToggle={setRenderToggle}
            hasGlobalAudioPlayer={feedViewCollapsed}
          />
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            px: 2,
            pb: 2,
            pointerEvents: "none",
            "& > *": { pointerEvents: "auto", height: "auto" },
          }}
        >
          <FeedFooter />
          {hasActiveGlobalAudioPlayerHeight > 0 && (
            <Box sx={{ ...footerTransitionSx, p: 1 }}>
              <GlobalAudioPlayer />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
